const data = {
    1: {
        question: 'Начнём со&nbsp;знакомства. Что лучше всего описывает тебя сейчас?',
        answears: { 
            1: {
                answear: 'У&nbsp;меня большой потенциал',
                return: 'Зёрнышко пшеницы становится мукой, семечко подсолнечника&nbsp;&mdash; маслом, а&nbsp;свёкла&nbsp;&mdash; сахаром. Агрономы &laquo;Русагро&raquo; знают, как культивировать потенциал, чтобы он&nbsp;прорастал на&nbsp;любой почве!',
            },
            2: {
                answear: 'Люблю жизнь и&nbsp;все её&nbsp;удовольствия',
                return: 'Вкус к&nbsp;жизни и&nbsp;её&nbsp;качество неразрывно связаны&nbsp;&mdash; наши инженеры по&nbsp;качеству это знают. Они и&nbsp;сами обожают картошку фри, пожаренную в&nbsp;маслах &laquo;Русагро&raquo;.',
            },
            3: {
                answear: 'Найду подход к&nbsp;любому',
                return: 'Иногда поладить с&nbsp;животными даже проще, чем с&nbsp;людьми. Ухаживая за&nbsp;свинками, ветеринары и&nbsp;зоотехники мясного направления &laquo;Русагро&raquo; заботятся о&nbsp;здоровье потребителей.',
            },
            4: {
                answear: 'Твёрд характером, но&nbsp;в&nbsp;душе&nbsp;&mdash; сама доброта',
                return: 'Как говорят в&nbsp;нашем сахарном направлении: &laquo;Путь свёклы от&nbsp;поля до&nbsp;сахарницы долог и&nbsp;непрост, зато результат всегда сладок&raquo;. Вот так&nbsp;же и&nbsp;с&nbsp;людьми!',
            },
        },
    },
    2: {
        question: 'А&nbsp;теперь представь место, в&nbsp;котором хочешь оказаться. Что ты&nbsp;видишь, слышишь, чувствуешь?',
        answears: { 
            1: {
                answear: 'Необъятный простор до&nbsp;горизонта',
                return: 'Просторы &laquo;Русагро&raquo; не&nbsp;безграничны, но&nbsp;8000 полей точно хватит, чтобы насладиться свободой!',
            },
            2: {
                answear: 'Стук по&nbsp;клавиатуре, оживлённые переговоры',
                return: 'Мы&nbsp;любим работать с&nbsp;людьми и&nbsp;для людей. Без поддержки тысяч сотрудников, занятых в&nbsp;продажах, маркетинге, управлении и&nbsp;ИТ, наши фермы и&nbsp;производство просто не&nbsp;могли&nbsp;бы существовать!',
            },
            3: {
                answear: 'Ритмичный шум конвейеров и&nbsp;центрифуг',
                return: '&laquo;Русагро&raquo;&nbsp;&mdash; это высокотехнологичные заводы с&nbsp;современными лабораториями. Инженерам, учёным и&nbsp;новаторам есть где развернуться!',
            },
            4: {
                answear: 'Не&nbsp;пойму. Кажется, кто-то хмыкает… Или хрюкает?!',
                return: 'Похоже на&nbsp;один из&nbsp;трех животноводческих кластеров &laquo;Русагро&raquo;. Нам есть что предложить тем, кто любит животных: почти 1,6 миллиона свинок, о&nbsp;которых нужно заботиться!',
            },
        },
    },
    3: {
        question: 'Кто окружает тебя в&nbsp;этом месте?',
        answears: { 
            1: {
                answear: 'Мастера своего дела',
                return: 'Наши люди&nbsp;&mdash; главная ценность &laquo;Русагро&raquo;. Мы&nbsp;уважаем профессионализм, поощряем обмен опытом и&nbsp;помогаем сотрудникам расти.',
            },
            2: {
                answear: 'Неравнодушные люди',
                return: 'Постоянное улучшение&nbsp;&mdash; одна из&nbsp;ценностей &laquo;Русагро&raquo;. Недавно запустили программу &laquo;Твои идеи работают&raquo;: каждый сотрудник может предложить, как повысить эффективность и&nbsp;безопасность производства, и&nbsp;получить вознаграждение за&nbsp;свою идею.',
            },
            3: {
                answear: 'Люди, на&nbsp;которых можно опереться',
                return: '&laquo;Русагро&raquo; ценит командную работу и&nbsp;честность. Направления компании не&nbsp;конкурируют друг с&nbsp;другом, а&nbsp;объединяют усилия, чтобы добиваться лучших результатов. Мы&nbsp;не&nbsp;замалчиваем проблемы и&nbsp;не&nbsp;скрываем полезный опыт от&nbsp;коллег.',
            },
            4: {
                answear: 'Люди, которые не&nbsp;боятся мечтать и&nbsp;делать',
                return: 'Результат&nbsp;&mdash; одна из&nbsp;ценностей &laquo;Русагро&raquo;. Мы&nbsp;стремимся во&nbsp;всём быть первыми и&nbsp;поддерживаем тех, кто идёт с&nbsp;нами в&nbsp;ногу. Проверено: с&nbsp;нами вырасти из&nbsp;стажёра в&nbsp;помощника начальника смены на&nbsp;сахарном заводе можно всего за&nbsp;три года.',
            },
        },
    },
    4: {
        question: 'Если&nbsp;бы можно было выбрать любого помощника по&nbsp;жизни, кто&nbsp;бы это был?',
        answears: { 
            1: {
                answear: 'Стая юрких фей&nbsp;&mdash; везде летают, всё подмечают',
                return: 'Очень похоже на&nbsp;парк дронов, которые помогают нам измерять границы полей и&nbsp;фиксировать состояние почв. Действительно полезно!',
            },
            2: {
                answear: 'Всевидящее Око&nbsp;&mdash; знает, что было, что есть и&nbsp;что будет',
                return: 'У&nbsp;нас таких&nbsp;&mdash; в&nbsp;каждом направлении! Компьютерное зрение, искусственный интеллект и&nbsp;даже нейросети помогают специалистам &laquo;Русагро&raquo; прогнозировать продажи, планировать севооборот и&nbsp;следить за&nbsp;здоровьем животных.',
            },
            3: {
                answear: 'Голова и&nbsp;руки&nbsp;&mdash; мои лучшие помощники',
                return: 'Дроны, искусственный интеллект, сложное оборудование&nbsp;&mdash; это прекрасно, но&nbsp;иногда можно положиться только на&nbsp;собственную ловкость, силу и&nbsp;внимательность. Например, если ты&nbsp;обвальщик мяса&nbsp;&mdash; тут только кольчуга пригодится!',
            },
            4: {
                answear: 'А&nbsp;можно армию роботов? Они работают, я&nbsp;наблюдаю',
                return: 'Можно! Только не&nbsp;армию роботов, а&nbsp;полностью автоматизированные производственные линии. Работают безопасно, поскольку исключают прямой контакт с&nbsp;продукцией, и&nbsp;быстро&nbsp;&mdash; полный цикл производства майонеза, например, занимает всего 25&nbsp;минут.',
            },
        },
    },
    5: {
        question: 'И&nbsp;наконец, в&nbsp;чём источник твоей внутренней силы?',
        answears: { 
            1: {
                answear: 'В&nbsp;знаниях и&nbsp;навыках',
                return: 'Самообразованию нет предела. Организуем тренинги, онлайн-курсы, обучающие квесты и&nbsp;работу с&nbsp;наставниками для всех сотрудников.',
            },
            2: {
                answear: 'В&nbsp;самых близких',
                return: 'Даём уверенность в&nbsp;завтрашнем дне: обеспечиваем безопасные и&nbsp;комфортные условия труда, организуем образовательные программы в&nbsp;учебных заведениях для детей сотрудников.',
            },
            3: {
                answear: 'В&nbsp;неиссякаемой энергии',
                return: 'Широкая программа ДМС&nbsp;&mdash; для здоровья, спортивный фестиваль &laquo;Честные игры&raquo;&nbsp;&mdash; для бодрости и&nbsp;правильной конкуренции. Гордимся нашими чемпионами!',
            },
            4: {
                answear: 'В&nbsp;неравнодушии',
                return: 'Даём возможность позаботиться о&nbsp;том, что вам небезразлично: рационально используем природные ресурсы, внедряем экологические инициативы и&nbsp;благотворительные проекты для поддержки родных регионов.',
            },
        },
    },
    result: {
        1: {
            title: 'Независимость',
            text: 'Как&nbsp;бы ни&nbsp;менялся мир вокруг, у&nbsp;тебя всегда есть&nbsp;ты. Вселенная напоминает: всё, что нам нужно,&nbsp;&mdash; уже в&nbsp;нас. Нужно лишь довериться себе: уж&nbsp;ты-то себя не&nbsp;подведёшь!',
            index: [1, 1],
        },
        2: {
            title: 'Движение',
            text: '&laquo;Жизнь&nbsp;&mdash; как езда на&nbsp;велосипеде. Чтобы сохранить равновесие, нужно двигаться&raquo;,&nbsp;&mdash; Вселенная нашептала эту мудрость Эйнштейну, а&nbsp;теперь напоминает и&nbsp;тебе. Не&nbsp;сдавайся перед горками и&nbsp;наслаждайся спусками!',
            index: [1, 2],
        },
        3: {
            title: 'Опоры',
            text: 'Подсолнуху нужны крепкие корни, чтобы расти, а&nbsp;человеку&nbsp;&mdash; опоры, чтобы не&nbsp;потерять себя. Окружай себя надёжными людьми и&nbsp;находи новые источники сил и&nbsp;вдохновения!',
            index: [1, 3],
        },
        4: {
            title: 'Мечта',
            text: 'Когда переполняют сомнения, прислушайся к&nbsp;шёпоту сердца&nbsp;&mdash; оно напомнит о&nbsp;самых заветных мечтах. Пусть мечта, как компас, укажет тебе путь, полный приключений и&nbsp;радости!',
            index: [1, 4],
        },
        5: {
            title: 'Баланс',
            text: 'Жизнь&nbsp;&mdash; это поиск баланса между стремлением к&nbsp;совершенству и&nbsp;осознанием его недостижимости. Как механизатор ведёт сеялки к&nbsp;цели, несмотря на&nbsp;непогоду, так и&nbsp;ты&nbsp;двигайся вперёд вопреки сомнениям.',
            index: [2, 1],
        },
        6: {
            title: 'Любовь к&nbsp;себе',
            text: 'Жизнь, как поле, открывает массу возможностей. Прежде чем хвататься за&nbsp;них, не&nbsp;забудь спросить себя: &laquo;А&nbsp;я&nbsp;точно этого хочу?&raquo; Иногда позволить себе отдохнуть&nbsp;&mdash; лучшее решение.',
            index: [2, 2],
        },
        7: {
            title: 'Отдых',
            text: 'Путь жизни не&nbsp;пройти без остановок. Время от&nbsp;времени нужно делать паузы, чтобы насладиться пейзажами и&nbsp;подумать над следующим поворотом. Не&nbsp;забывай благодарить тех, кто делает эти паузы возможными!',
            index: [2, 3],
        },
        8: {
            title: 'Спонтанность',
            text: 'Жизнь похожа на&nbsp;полёт на&nbsp;воздушном шаре: один порыв ветра может изменить любой тщательно продуманный маршрут. Не&nbsp;пасуй перед судьбой! Иногда самые живописные виды открываются за&nbsp;поворотом, который мы&nbsp;не&nbsp;собирались делать.',
            index: [2, 4],
        },
        9: {
            title: 'Преемственность',
            text: 'Как колоску нужны сильные корни, чтобы расти, так и&nbsp;нам нужны люди, которые будут делиться знаниями и&nbsp;опытом. Укрепляй свою &laquo;корневую систему&raquo;, впитывай опыт и&nbsp;охотно передавай его другим!',
            index: [3, 1],
        },
        10: {
            title: 'Возможность делиться',
            text: 'Как семечко подсолнечника, которым можно накормить и&nbsp;людей, и&nbsp;животных, ты&nbsp;питаешь всех своей энергией. Не&nbsp;переставай делиться своим теплом с&nbsp;окружающими, и&nbsp;твоя жизнь наполнится вдохновением!',
            index: [3, 2],
        },
        11: {
            title: 'Близкие',
            text: 'Близкие люди, как солнце, дарят нам тепло и&nbsp;энергию. Их&nbsp;поддержка вдохновляет идти вперёд, несмотря на&nbsp;трудности. Оставайся сильным ради самых дорогих!',
            index: [3, 3],
        },
        12: {
            title: 'Перемены',
            text: 'Как ловкий жонглёр, ты&nbsp;подхватываешь в&nbsp;воздухе всё, что подкидывает тебе жизнь. Не&nbsp;бойся сюрпризов&nbsp;&mdash; именно они делают твоё представление зрелищным и&nbsp;захватывающим!',
            index: [3, 4],
        },
        13: {
            title: 'Возможность выбора',
            text: 'Как опытный агроном тщательно планирует севооборот, так и&nbsp;ты&nbsp;выбираешь, что впустить в&nbsp;свою жизнь. А&nbsp;выбрав, не&nbsp;жалеешь сил на&nbsp;уход. Пусть каждый росток на&nbsp;твоём поле жизни будет символом твоего трудолюбия и&nbsp;заботы!',
            index: [4, 1],
        },
        14: {
            title: 'Открытия',
            text: 'Как и&nbsp;увлечённого технолога, тебя манит всё новое и&nbsp;неизведанное. На&nbsp;пути к&nbsp;приключениям ты&nbsp;не&nbsp;знаешь преград. Не&nbsp;забывай только, что настоящие сокровища&nbsp;&mdash; люди, впечатления, опыт&nbsp;&mdash; могут оказаться гораздо ближе, чем кажется.',
            index: [4, 2],
        },
        15: {
            title: 'Стабильность',
            text: 'Как сахарная свёкла уходит корнями глубоко в&nbsp;землю, так и&nbsp;тебе нужно чувствовать твёрдую почву под ногами, чтобы расти и&nbsp;развиваться. Позволь себе смело тянуться к&nbsp;солнцу и&nbsp;распускать листья, не&nbsp;боясь ветров и&nbsp;ненастий!',
            index: [4, 3],
        },
        16: {
            title: 'Препятствия',
            text: 'Иногда мы&nbsp;готовы преодолеть любые препятствия, чтобы добраться до&nbsp;цели. А&nbsp;иногда препятствия&nbsp;&mdash; это главное в&nbsp;пути. Позволь себе учиться чему-то новому у&nbsp;каждого сорняка, дождя и&nbsp;порыва ветра на&nbsp;пути к&nbsp;мечте.',
            index: [4, 4],
        },
    }
}

export { data }